import { render, staticRenderFns } from "./MessageBoxInputModalClose.vue?vue&type=template&id=ebadb164&scoped=true&"
import script from "./MessageBoxInputModalClose.vue?vue&type=script&lang=js&"
export * from "./MessageBoxInputModalClose.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxInputModalClose.vue?vue&type=style&index=0&id=ebadb164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebadb164",
  null
  
)

export default component.exports